import {spellArtCleanseFamily} from './vfx-families/cleanse';
import type {MagicRecipe} from './vfx-recipe-types';
import type {VfxDiagnostic} from './vfx-recipe-contract';

export interface VfxFamilyEffect {
  readonly group:any; readonly parts:any[]; readonly geometries:any[]; readonly root:any;
  update(elapsed:number,duration:number,position:any,height:number,camera:any):void;
  dispose():void;
  receipt():Record<string,unknown>;
}
export interface VfxFamily {
  readonly preview?:{readonly bodyReachScale:number;readonly topScale:number};
  readonly id:string; readonly legacyContactStyle?:string; readonly programPrefix:string;
  diagnostics(recipe:Record<string,any>,path:string):readonly VfxDiagnostic[];
  textures(recipe:MagicRecipe):readonly string[];
  validAssets(assets:Record<string,any>,recipe:MagicRecipe):boolean;
  programKey(recipe:MagicRecipe):string;
  create(T:any,world:any,body:{visualRoot?:any;position:any;height:number},maps:any[],target:string,recipe:MagicRecipe):VfxFamilyEffect;
}
/** A family adds its module and this registration; Node, encounter and preview share the contract. */
export const VFX_FAMILIES:Readonly<Record<string,VfxFamily>> = {cleanse:spellArtCleanseFamily};
export function vfxFamilyForRecipe(recipe:Record<string,any>):VfxFamily|undefined {
  if(recipe.contactStyle==='family')return typeof recipe.family==='string'&&Object.prototype.hasOwnProperty.call(VFX_FAMILIES,recipe.family)
    ? VFX_FAMILIES[recipe.family] : undefined;
  if(typeof recipe.contactStyle!=='string')return undefined;
  return Object.values(VFX_FAMILIES).find(f=>f.legacyContactStyle===recipe.contactStyle);
}
